import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchApplicationPaymentContracts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/applications-payment-contracts', {
            params: queryParams,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
